// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9086849","553":"d3f2fbde","977":"a6946415"}[chunkId] + ".chunk.js";
};